import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import Text from "@/shared-components/text/components/Text";
import { getArtworkArtistDisplayName } from "@/utils/artworkArtists";
import NumberUtils from "@/utils/number.utils";

import ArtworkImage from "./ArtworkImage";

import "./styles/ArtworkSliderCard.css";

function truncateTitle(title, maxLength = 30) {
  if (typeof title !== "string") {
    return title;
  }

  const normalized = title.trim();
  if (normalized.length <= maxLength) {
    return normalized;
  }

  return `${normalized.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

function normalizeArtistNameFallback(value) {
  return typeof value === "string" && value.trim().length > 0 ? value.trim() : null;
}

export default function ArtworkSliderCard({
  artworkData,
  artistNameFallback = null,
  cardClassName = "",
  imageClassName = "",
  hideText = false,
  showLimitedEditionIcon = false,
  maxTitleLength = 30,
  onClick,
}) {
  const artworkAbout = artworkData?.artwork_about ?? {};
  const resolvedArtistName = getArtworkArtistDisplayName(artworkData);
  const artistName =
    normalizeArtistNameFallback(resolvedArtistName && resolvedArtistName !== "-" ? resolvedArtistName : null)
    ?? normalizeArtistNameFallback(artistNameFallback)
    ?? "-";
  const artworkTitle = artworkAbout?.artwork_title ?? artworkData?.title ?? "-";
  const displayedArtworkTitle = truncateTitle(artworkTitle, maxTitleLength);
  const priceText = (() => {
    const price = artworkAbout?.artwork_price;
    const currency = artworkAbout?.artwork_currency ?? "EUR";
    if (typeof price === "number" && Number.isFinite(price)) {
      return NumberUtils.getArtworkPrice(price, currency);
    }
    if (typeof price === "string" && price.trim().length > 0) {
      return price.trim();
    }
    return null;
  })();

  return (
    <>
      <div
        className={`artwork-slider-card__card ${cardClassName} ${
          onClick ? "pointer" : ""
        }`}
        onClick={onClick}
      >
        <ArtworkImage
          artworkData={artworkData}
          image={artworkData.artwork_media.artwork_main_picture.image_id}
          imageClassName={imageClassName}
          imageTemplateClassName={imageClassName}
          style={{
            aspectRatio:
              artworkData.artwork_media.artwork_main_picture.image_original_data
                .aspect_ratio,
          }}
          forceSmaller={300}
          forceSmallerDimension={
            artworkData.artwork_media.artwork_main_picture.image_original_data
              .aspect_ratio > 1
              ? "height"
              : "width"
          }
        />

        {!hideText && (
          <div
            className={`artworks-slider-card__card-container ${
              showLimitedEditionIcon ? "le-slider-card__card-container" : ""
            }`}
          >
            <div className="artworks-slider-card__card-content">
              <div className="artworks-slider-card__card-heading-row">
                <Text
                  className="artworks-slider-card__card-content-title dots-on-overflow font-size-medium"
                  title={artworkTitle}
                  paragraph>
                  {displayedArtworkTitle}
                </Text>
                {showLimitedEditionIcon ? (
                  <LimitedEditionIcon className="le-slider-card__limited-edition-icon" />
                ) : null}
              </div>

              <div className="artworks-slider-card__card-meta-row artworks-slider-card__card-content-text artist font-size-small">
                <span className="artworks-slider-card__card-meta-primary">{artistName}</span>
                {priceText ? (
                  <span className="artworks-slider-card__card-meta-price">{priceText}</span>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
